import { Navigate } from "react-router-dom";
import useSupportSessionGuard from "../hooks/useSupportSessionGuard";

export default function SuperAdminRoute({ children }) {
  const { checking, supportUser } = useSupportSessionGuard();

  if (checking) {
    return <div className="min-h-screen bg-[#171717]" />;
  }

  if (!supportUser?.id) {
    return <Navigate to="/u/admin/login" replace />;
  }

  if (!(supportUser.isSuperAdmin || String(supportUser.role || "").toLowerCase() === "superadmin")) {
    return <Navigate to="/u/support/admin" replace />;
  }

  return children;
}
